import { render, staticRenderFns } from "./citationStatsTemplateConfigDetail.vue?vue&type=template&id=466a2106&scoped=true"
import script from "./citationStatsTemplateConfigDetail.vue?vue&type=script&lang=js"
export * from "./citationStatsTemplateConfigDetail.vue?vue&type=script&lang=js"
import style0 from "./citationStatsTemplateConfigDetail.vue?vue&type=style&index=0&id=466a2106&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "466a2106",
  null
  
)

export default component.exports